import { useSelector } from 'react-redux';
import { getOpenPreviewDRG } from '../redux/openPreviewDRGSlice';
import { baseStyles } from '../pages/Editor/Regulatory/styles/styles';

function CheckHandleNodeEvent(data, selected, handleId) {
    const openPreviewDRG = useSelector(getOpenPreviewDRG);
    if (data.activeSourceHandleId || data.activeTargetHandleId) {
        if (data.activeSourceHandleId === handleId || data.activeTargetHandleId === handleId) {
            return baseStyles.enableHandle({ selected });
        } else {
            return baseStyles.disableHandle({ selected });
        }
    } else {
        if (data.showHandle && !openPreviewDRG) {
            return baseStyles.enableHandle({ selected });
        } else {
            return baseStyles.disableHandle({ selected });
        }
    }
}

export default CheckHandleNodeEvent